import { Box, Button, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import TargetExplorer from "../../components/organisms/targetExplorer/TargetExplorer";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DataTargetList = () => {
  const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User

  const [isAdmin, setIsAdmin] = useState(true);

  const navigate = useNavigate();

  const addNewTarget = (event: React.MouseEvent<HTMLButtonElement>) => {
    const url = "/AddDataTarget";
    if (event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  useEffect(() => {
    if (roles && roles.length > 0) {
      setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
  }, [roles]);

  //request Access
  const requestAccess = () => {
    window.open(
      "https://rttms.service-now.com/rttms/#/order/item/Unity_Data_Lake_Data_Request",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <>
      <Box sx={{ paddingBottom: "10px" }}>
        <Grid container spacing={2} direction="row">
          <Grid item xs={8}>
            <h1 style={{ textAlign: "left" }}>Data Targets </h1>
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {isAdmin && (
              <Button
                id="1e1ea04e-bd6d-4d05-a978-e042a8f5bb0d"
                color="primary"
                variant="contained"
                onClick={addNewTarget}
                endIcon={<AddIcon />}
              >
                Add Data Target
              </Button>
            )}
          </Grid>
        </Grid>
        {isAdmin && (
          <Grid container sx={{ paddingBottom: "10px" }}>
            <h2>Request Target</h2>
            <p>
              You are able to request to add a Target if you have a valid
              reason. Click the 'Request Target' button to be directed to RTTMS
              and complete the form. When filling out this form, please include
              all technical information that will assist with processing this
              request
            </p>
            <Button
              id="12490db5-6ae5-4d74-90ea-3249601fa811"
              color="primary"
              variant="contained"
              onClick={requestAccess}
            >
              Request Target
            </Button>
          </Grid>
        )}
      </Box>
      <TargetExplorer isAdmin={isAdmin} />
    </>
  );
};

export default DataTargetList;
